import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const TermsAndConditions = () => {

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <section className="bg-blue-900 text-white py-12">
        <div className="container mx-auto px-4">
          <Link to="/" className="inline-flex items-center text-blue-200 hover:text-white mb-4 transition-colors">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Home
          </Link>
          <h1 className="text-4xl md:text-5xl font-bold">
            Terms and Conditions of Contract
          </h1>
        </div>
      </section>

      {/* Acceptance Notice */}
      <section className="py-8 bg-gray-50">
        <div className="container mx-auto px-4 max-w-5xl">
          <div className="bg-white border-2 border-blue-900 rounded-lg p-6 shadow-md">
            <h2 className="text-2xl font-bold text-blue-900 mb-4">Acceptance of Terms</h2>
            <p className="text-gray-800 leading-relaxed mb-4">
              These Terms and Conditions are incorporated by reference into every estimate, quote, proposal, invoice, purchase order, work order, and service call issued by Studerus Electric Inc., and are deemed accepted by, and legally binding on, the Customer upon the earliest of any of the following:
            </p>
            
            <ul className="space-y-3 mb-4 ml-4">
              <li className="text-gray-800 leading-relaxed">
                <strong className="text-blue-900">(a)</strong> verbal or written agreement to engage Studerus Electric's services, including by telephone, text, email, or in-person instruction to proceed;
              </li>
              <li className="text-gray-800 leading-relaxed">
                <strong className="text-blue-900">(b)</strong> payment, or partial payment, of any invoice, deposit, or progress billing;
              </li>
              <li className="text-gray-800 leading-relaxed">
                <strong className="text-blue-900">(c)</strong> issuance of a purchase order, work order, service request, or written authorization to proceed;
              </li>
              <li className="text-gray-800 leading-relaxed">
                <strong className="text-blue-900">(d)</strong> execution of an estimate, quote, proposal, or acceptance page by handwritten, electronic, or digital signature; or
              </li>
              <li className="text-gray-800 leading-relaxed">
                <strong className="text-blue-900">(e)</strong> permitting Studerus Electric to commence or continue any Work on site.
              </li>
            </ul>
            
            <p className="text-gray-800 leading-relaxed">
              The Customer's engagement of Studerus Electric under any of these methods constitutes conclusive evidence that the Customer has received, reviewed, and agreed to these Terms and Conditions as posted at <a href="https://studeruselectric.com/terms-and-conditions" className="text-blue-900 font-semibold hover:underline">studeruselectric.com/terms</a> and as in effect on the date of engagement.
            </p>
          </div>
        </div>
      </section>

      {/* Adobe Sign Embed */}
      <section className="py-12">
        <div className="container mx-auto px-4">
          <div className="w-full" style={{ minHeight: '800px' }}>
            <iframe 
              src="https://na4.documents.adobe.com/public/esignWidget?wid=CBFCIBAA3AAABLblqZhDRJ0pP-YDCOvz_tuKtHZ0jvnJEZO07N2kXGqintVaGusBVO-4__HBHRRwVOEWl39c*&hosted=false" 
              width="100%" 
              height="100%" 
              frameBorder="0" 
              style={{ border: 0, overflow: 'hidden', minHeight: '800px', minWidth: '600px' }}
              title="Terms and Conditions - Adobe Sign"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsAndConditions;
